import {readSigninAttempt} from '../services/shopify/signin-flow.js';
import {shopifyAuthNotice} from '../services/shopify/auth-return.js';
import './shopify-connect.css';
/**
 * Sign In Route
 * Two-panel grid layout (columns on desktop, rows on portrait)
 * Grayscale colors only from launCh.css
 */

import PubSub from 'pubsub-js';
import { coBrandHTML, magnetBrandHTML } from '../core/coBrand.js';
import AppBroadcast from '../../../../shared/appBroadcast.js';
import AuthController from '../services/AuthController.js';
import { MicrocopyManager } from '../../../../shared/meta_microcopy_i18n.js';
import { shakeAndToast, validateEmail } from '../../../../shared/formHelpers.js';
import { getSuspendedEditor } from '../core/magnetEditorSession.js';

export function render() {
  return `
    <div class="auth-container">
      <div class="auth-left">
        ${magnetBrandHTML()}
        <h1 data-meta-copywrite-i118n='{"token": "welcome_back", "attribute": "textContent"}'>Welcome back</h1>
        <p data-meta-copywrite-i118n='{"token": "please_enter_your_details", "attribute": "textContent"}'>Sign in to your Mach Five Magnet account</p>

        <div class="auth-content">
          ${shopifyAuthNotice()}
          ${readSigninAttempt()?.resume ? '<p role="status">Sign in to link your Shopify account. You’ll confirm the link next.</p>' : ''}
          ${getSuspendedEditor() ? '<p role="status">Your unfinished magnet is held in this tab. Sign in with the same account to continue. Keep this tab open; your edits have not been saved.</p>' : ''}
          <form id="loginForm" class="auth-form" novalidate>
            <div class="form-group">
              <label for="email" data-meta-copywrite-i118n='{"token": "email", "attribute": "textContent"}'>EMAIL</label>
              <input
                type="text"
                id="email"
                name="email"
                placeholder="Enter your email"
                data-meta-copywrite-i118n='{"token": "enter_your_email", "attribute": "placeholder"}'
                autocomplete="email"
              />
            </div>

            <div class="form-group">
              <label for="password" data-meta-copywrite-i118n='{"token": "password", "attribute": "textContent"}'>PASSWORD</label>
              <div class="password-input-wrapper">
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                  data-meta-copywrite-i118n='{"token": "enter_your_password", "attribute": "placeholder"}'
                  autocomplete="current-password"
                />
                <button type="button" id="togglePassword" class="toggle-password" aria-label="Toggle password visibility">
                  <svg id="eyeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
              </div>
            </div>

            <div class="form-consent">
              <input type="checkbox" id="rememberEmail" name="rememberEmail" />
              <label for="rememberEmail" data-meta-copywrite-i118n='{"token": "remember_email", "attribute": "textContent"}'>Remember my email</label>
            </div>

            <div class="form-footer">
              <a href="#/forgot" class="link-brand--uc__underline" data-meta-copywrite-i118n='{"token": "forgot_password", "attribute": "textContent"}'>FORGOT PASSWORD</a>
            </div>

            <button type="submit" class="btn" data-meta-copywrite-i118n='{"token": "sign_in", "attribute": "textContent"}'>SIGN IN</button>
          </form>

          <a class="btn-outline" id="shopifySigninBtn" hidden href="?shopifySignin=#/splash">Continue with Shopify</a>
          <div class="auth-divider" id="passkeyDivider" style="display:none">OR</div>
          <button type="button" class="btn-outline" id="passkeySigninBtn" style="display:none">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <circle cx="8" cy="8" r="5"></circle>
              <path d="M11.5 11.5 21 21M17 15l3 3M14 18l2 2"></path>
            </svg>
            Sign in with a passkey
          </button>
          <p class="auth-hint" id="passkeyHint" style="display:none">Works best in Chrome, Edge, or Safari. On Firefox or Linux, you may need a physical security key.</p>

          <p class="auth-switch">
            <span data-meta-copywrite-i118n='{"token": "dont_have_an_account", "attribute": "textContent"}'>START YOUR FREE ACCOUNT</span> &nbsp;  <a class="link-brand--uc__underline" href="#/signup" data-meta-copywrite-i118n='{"token": "sign_up", "attribute": "textContent"}'>SIGN UP</a>
          </p>

          <p class="auth-legal">
            <a href="https://machfivemagnet.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy</a>
            <span aria-hidden="true">·</span>
            <a href="https://machfivemagnet.com/terms/" target="_blank" rel="noopener noreferrer">Terms</a>
          </p>
        </div>
      </div>

      <div class="auth-right">
        <div class="auth-right-content">
          ${coBrandHTML()}
          <h2 class="auth-hero-title">
            Turn conversations into conversions.
          </h2>
          <p class="auth-hero-description">
            Replace static forms with conversational magnets that qualify, score, and capture
            every lead in real time. No code required.
          </p>
        </div>
      </div>
    </div>
  `;
}

export function init() {
  console.log('[SigninRoute] Initialized');
  const shopifyButton=document.getElementById('shopifySigninBtn');
  fetch(AuthController.CONFIG.BASE_URL+'/shopify-signin/available').then(r=>r.json()).then(data=>{
    if(shopifyButton?.isConnected&&data.enabled===true)shopifyButton.hidden=false;
  }).catch(()=>{});

  const form = document.getElementById('loginForm');
  const emailInput = document.getElementById('email');
  const passwordInput = document.getElementById('password');
  const togglePasswordBtn = document.getElementById('togglePassword');
  const rememberInput = document.getElementById('rememberEmail');

  // Remember-email: prefill from a prior "remember my email" sign-in. Email only —
  // never the password — so this is a plain, unencrypted localStorage read/write.
  const rememberedEmail = localStorage.getItem(AuthController.CONFIG.LS_KEYS.REMEMBERED_EMAIL);
  if (rememberedEmail && emailInput && rememberInput) {
    emailInput.value = rememberedEmail;
    rememberInput.checked = true;
    passwordInput?.focus();
  }

  // Password visibility toggle
  togglePasswordBtn?.addEventListener('click', () => {
    const type = passwordInput.type === 'password' ? 'text' : 'password';
    passwordInput.type = type;
  });

  // Passkey sign-in — feature-detected, hidden on a browser with no WebAuthn
  // support rather than shown and failing on click.
  const passkeyBtn = document.getElementById('passkeySigninBtn');
  const passkeyDivider = document.getElementById('passkeyDivider');
  const passkeyHint = document.getElementById('passkeyHint');
  if (window.PublicKeyCredential && passkeyBtn && passkeyDivider) {
    passkeyBtn.style.display = '';
    passkeyDivider.style.display = '';
    // Firefox on Linux (and Linux more broadly) has no platform passkey
    // provider and no cross-device/QR fallback — the browser only offers a
    // physical security key prompt, with no explanation. Password sign-in
    // stays fully available either way; this is purely about not leaving
    // someone stuck at an unexplained prompt. The support caveat used to sit
    // permanently under the button — the noisiest line on the screen for the
    // vast majority who never need it. It now surfaces exactly when it is
    // useful: after a ceremony that fails or gets canceled (the stuck case),
    // with the same text always available as the button's tooltip.
    if (passkeyHint) passkeyBtn.title = passkeyHint.textContent;
    passkeyBtn.addEventListener('click', () => handlePasskeySignin());
  }

  // Form submit handler
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();

    const email = emailInput.value.trim();
    const password = passwordInput.value;

    // Sequential validation - stop on first error. Must run BEFORE the remember-email
    // persist below — a malformed/garbage email that fails validation here should never
    // get written to localStorage, or it would keep prefilling on every future visit
    // even though it could never actually be submitted.
    if (!validateEmail(email, emailInput)) return;
    if (!validatePassword(password, passwordInput)) return;

    // Save/clear regardless of the sign-in result itself (still ahead of the actual
    // signin call): the checkbox is the user's stated intent, and a failed attempt
    // (e.g. typo'd password) shouldn't discard an email they asked to have remembered
    // for the retry — only an invalid EMAIL (caught above) should block persisting it.
    if (rememberInput?.checked) {
      localStorage.setItem(AuthController.CONFIG.LS_KEYS.REMEMBERED_EMAIL, email);
    } else {
      localStorage.removeItem(AuthController.CONFIG.LS_KEYS.REMEMBERED_EMAIL);
    }

    // Proceed with API call
    await handleSignin(email, password);
  });

  // Prevent default navigation for forgot password link
  document.getElementById('link--uc__underline')?.addEventListener('click', (e) => {
    e.preventDefault();
    PubSub.publish(AppBroadcast.AUTH_FORGOT);
  });

  // Prevent default navigation for sign up link - use ROUTE_NAV
  const signupLink = document.querySelector('.auth-switch a[href="#/signup"]');
  signupLink?.addEventListener('click', (e) => {
    e.preventDefault();
    console.log('[SigninRoute] Sign up link clicked - navigating to signup');
    PubSub.publish(AppBroadcast.ROUTE_NAV, { route: 'signup' });
  });
}

/**
 * Validate password field - shake and toast on error
 */
function validatePassword(password, inputElement) {
  // Check if empty
  if (!password) {
    shakeAndToast(inputElement, MicrocopyManager.get('validation_password_required'));
    return false;
  }

  // Check length (min 10 chars)
  if (password.length < 10) {
    shakeAndToast(inputElement, MicrocopyManager.get('validation_password_min_length'));
    return false;
  }

  return true;
}

/**
 * Handle signin API call
 */
async function handleSignin(email, password) {
  const submitBtn = document.querySelector('.btn');
  submitBtn.disabled = true;
  submitBtn.textContent = MicrocopyManager.get('loading_signing_in');

  try {

    // Password sent over TLS, hashed server-side with Argon2id.
    // Call AuthController.doSignin() - handles API call, token storage, and navigation
    const result = await AuthController.doSignin(email, password);

    if (result.ok) {
      // Success - AuthController handles token storage, entity persistence, and navigation
      console.log('[SigninRoute] Signin successful');

      // Toast notification
      if (typeof neodigmToast !== 'undefined') {
        neodigmToast.q(MicrocopyManager.get('success_welcome_back'), 'success');
      }

      // Publish success event
      PubSub.publish(AppBroadcast.AUTH_SIGNIN_SUCCESS, {
        entity: AuthController.getEntity()
      });
    } else if (result.resetRequired) {
      // Password reset required - AuthController handles navigation
      console.log('[SigninRoute] Password reset required');
      if (typeof neodigmToast !== 'undefined') {
        neodigmToast.q(MicrocopyManager.get('error_password_reset_required'), 'warning');
      }
    } else {
      // Error from API
      if (typeof neodigmToast !== 'undefined') {
        neodigmToast.q(result.error || MicrocopyManager.get('error_signin_failed'), 'danger');
      }
      submitBtn.disabled = false;
      submitBtn.textContent = (MicrocopyManager.get('sign_in') || 'Sign in').toUpperCase();
    }
  } catch (error) {
    console.error('[SigninRoute] Sign in error:', error);
    if (typeof neodigmToast !== 'undefined') {
      neodigmToast.q(error.message || MicrocopyManager.get('error_network'), 'danger');
    }
    submitBtn.disabled = false;
    submitBtn.textContent = (MicrocopyManager.get('sign_in') || 'Sign in').toUpperCase();

    PubSub.publish(AppBroadcast.AUTH_SIGNIN_FAIL, {
      message: error.message
    });
  }
}

/**
 * Handle passkey signin — no email/password involved, so this doesn't touch
 * either input or the remember-email persistence.
 */
async function handlePasskeySignin() {
  const passkeyBtn = document.getElementById('passkeySigninBtn');
  passkeyBtn.disabled = true;

  try {
    const result = await AuthController.doPasskeySignin();

    if (result.ok) {
      console.log('[SigninRoute] Passkey signin successful');
      if (typeof neodigmToast !== 'undefined') {
        neodigmToast.q(MicrocopyManager.get('success_welcome_back'), 'success');
      }
      PubSub.publish(AppBroadcast.AUTH_SIGNIN_SUCCESS, { entity: AuthController.getEntity() });
    } else {
      // The stuck case the support caveat exists for — surface it now.
      document.getElementById('passkeyHint')?.style.removeProperty('display');
    }
    if (!result.ok && !result.canceled) {
      // A user-canceled ceremony (closed the prompt, no passkey available) is
      // an ordinary decline, not a toast-worthy error — the password form is
      // still right there.
      if (typeof neodigmToast !== 'undefined') {
        neodigmToast.q(result.error || MicrocopyManager.get('error_signin_failed'), 'danger');
      }
    }
  } catch (error) {
    console.error('[SigninRoute] Passkey signin error:', error);
    if (typeof neodigmToast !== 'undefined') {
      neodigmToast.q(error.message || MicrocopyManager.get('error_network'), 'danger');
    }
  } finally {
    passkeyBtn.disabled = false;
  }
}
